var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerificationPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_49458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99968 0.833496C8.18668 0.833496 6.4144 1.37111 4.90695 2.37836C3.3995 3.3856 2.22459 4.81724 1.53078 6.49223C0.83698 8.16722 0.655449 10.0103 1.00915 11.7885C1.36284 13.5666 2.23589 15.2 3.51787 16.482C4.79985 17.764 6.43319 18.637 8.21135 18.9907C9.98951 19.3444 11.8326 19.1629 13.5076 18.4691C15.1826 17.7753 16.6142 16.6003 17.6215 15.0929C18.6287 13.5854 19.1663 11.8132 19.1663 10.0002C19.1635 7.56989 18.1968 5.23998 16.4783 3.52152C14.7599 1.80306 12.4299 0.836363 9.99968 0.833496ZM13.0888 13.0893C12.9326 13.2456 12.7206 13.3333 12.4997 13.3333C12.2787 13.3333 12.0668 13.2456 11.9105 13.0893L9.41051 10.5893C9.25422 10.4331 9.16639 10.2212 9.16634 10.0002V5.00016C9.16634 4.77915 9.25414 4.56719 9.41042 4.41091C9.5667 4.25463 9.77866 4.16683 9.99968 4.16683C10.2207 4.16683 10.4327 4.25463 10.5889 4.41091C10.7452 4.56719 10.833 4.77915 10.833 5.00016V9.65516L13.0888 11.911C13.2451 12.0673 13.3328 12.2792 13.3328 12.5002C13.3328 12.7211 13.2451 12.9331 13.0888 13.0893Z",
    fill: "#FB607F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_49458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationPending);
export default __webpack_public_path__ + "static/media/VerificationPending.30a7ab31b6448e28e9bf24292dfab51e.svg";
export { ForwardRef as ReactComponent };